import { SelectAsyncInput } from '@core/components/Select';
import empresaApi from 'app/services/api/empresaApi';
import React, { useEffect, useState } from 'react';

const SelectEmpresa = ({
  id,
  multiple,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  natureza = '',
  required,
  disabled,
  style,
  options,
  returnData,
  disableOptions,
  setDisableOptions,
}) => {
  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    if (returnData) {
      returnData(searchData);
    }
  }, [searchData, returnData]);

  const handleChange = (event, value) => {
    if (value?.some((empresa) => empresa.id === 'TODAS')) {
      setDisableOptions(true);
      value = value?.filter((empresa) => empresa.id === 'TODAS');
    } else {
      setDisableOptions(false);
    }
    onChange({
      target: {
        id,
        value,
      },
    });
    value = [];
  };

  return (
    <SelectAsyncInput
      style={style}
      options={options}
      multiple={multiple}
      id={id}
      required={required}
      name={name}
      label={label}
      value={value}
      onChange={handleChange}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.pessoa?.nome;
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        const resp = await empresaApi.selectEmpresa({
          page: next,
          size: 100,
          sort: 'pessoa.nome,asc',
          query: query,
          ativo: true,
        });

        const totalItems = resp.headers['x-total-count'];
        const respData = resp?.data?.content || [];
        let data;

        if (query?.length === 0) {
          data = [{ id: 'TODAS', pessoa: { nome: 'Todas' } }, ...respData];
        } else {
          data = respData;
        }

        return { data, totalItems };
      }}
      fetchOnFocus
      disabled={disabled}
      setSearchData={setSearchData}
      renderOption={(option) => (
        <li
          key={option.id}
          style={{
            opacity: disableOptions && option.id !== 'TODAS' ? 0.5 : 1,
          }}
        >
          {option.pessoa.nome}
        </li>
      )}
    />
  );
};

export default SelectEmpresa;
